import { createPortal } from "react-dom";
import { AnimatePresence } from "framer-motion";
import { useWalkthrough } from "./WalkthroughContext";
import { IntroCards } from "./IntroCards";
import { TourOverlay } from "./TourOverlay";

export function WalkthroughOverlay() {
  const { phase } = useWalkthrough();

  if (phase === "idle") return null;

  return createPortal(
    <AnimatePresence mode="wait">
      {phase === "intro" && <IntroCards key="intro" />}
      {phase === "tour" && <TourOverlay key="tour" />}
    </AnimatePresence>,
    document.body
  );
}
